<h2 mat-dialog-title class="dialog-header">
  <span>Devis {{ data.devisReference ?? data.devisId }}</span>
  <span class="badge-statut" [ngClass]="statClass">{{ data.devisStatut }}</span>
</h2>

<mat-dialog-content class="view-content">

  <!-- ───────── ALERTES STATUT ───────── -->
  <div *ngIf="data.devisStatut === DevisStatut.REFUSE" class="alert alert-refuse">
    <mat-icon>cancel</mat-icon>
    <div>
      <strong>Devis refusé</strong>
      <p *ngIf="data.devisMotifRefus">{{ data.devisMotifRefus }}</p>
      <p *ngIf="!data.devisMotifRefus" class="motif-vide">Aucun motif renseigné.</p>
    </div>
  </div>

  <div *ngIf="data.devisMotifRetourArriere" class="alert alert-retour">
    <mat-icon>undo</mat-icon>
    <div>
      <strong>Retour en arrière depuis EN ATTENTE</strong>
      <p><span class="motif-label">Motif de retour :</span> {{ data.devisMotifRetourArriere }}</p>
    </div>
  </div>

  <div *ngIf="data.devisStatut === DevisStatut.ACCEPTE" class="alert alert-accepte">
    <mat-icon>check_circle</mat-icon>
    <div>
      <strong>Devis accepté</strong>
      <div class="accepte-details">
        <span *ngIf="data.devisNumeroBdc">
          <mat-icon class="inline-icon">receipt</mat-icon> N° BDC : <strong>{{ data.devisNumeroBdc }}</strong>
        </span>
        <span *ngIf="data.devisDateFinTravaux">
          <mat-icon class="inline-icon">event</mat-icon> Fin des travaux :
          <strong>{{ data.devisDateFinTravaux | date:'dd/MM/yyyy' }}</strong>
        </span>
      </div>
    </div>
  </div>

  <!-- ───────── SECTION 1 : IDENTIFICATION ───────── -->
  <div class="section-title">Identification</div>
  <div class="info-grid">
    <div class="info-item">
      <span class="label">N° Devis</span>
      <span class="value">{{ data.devisReference ?? '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">Bénéficiaire</span>
      <span class="value">{{ data.devisBeneficiaire ?? '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">Projet</span>
      <span class="value">{{ data.febProjectNom ?? '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">Division</span>
      <span class="value">{{ data.febDivisionDemandeurNom ?? '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">Entité SNCF</span>
      <span class="value">{{ data.febEntiteSncfNom ?? '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">Créé le</span>
      <span class="value">{{ data.devisCreatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
    </div>
    <div class="info-item">
      <span class="label">Mis à jour le</span>
      <span class="value">{{ data.devisUpdatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
    </div>
    <div class="info-item" *ngIf="data.devisNumeroContrat">
      <span class="label">N° Contrat</span>
      <span class="value">{{ data.devisNumeroContrat }}</span>
    </div>
    <div class="info-item" *ngIf="data.devisNomContrat">
      <span class="label">Nom Contrat</span>
      <span class="value">{{ data.devisNomContrat }}</span>
    </div>
  </div>

  <!-- ───────── SECTION 2 : CHIFFRAGE ───────── -->
  <div class="section-title">Chiffrage</div>
  <div class="info-grid">
    <div class="info-item">
      <span class="label">Prestation majorée</span>
      <span class="value">
        <mat-icon [class.icon-oui]="data.devisMajore" [class.icon-non]="!data.devisMajore">
          {{ data.devisMajore ? 'check_circle' : 'cancel' }}
        </mat-icon>
        {{ data.devisMajore ? 'Oui' : 'Non' }}
      </span>
    </div>
    <div class="info-item">
      <span class="label">Prix UO grille</span>
      <span class="value">
        {{ (data.devisMajore ? data.febPrixUoGrilleMajore : data.febPrixUoGrille) != null
           ? ((data.devisMajore ? data.febPrixUoGrilleMajore : data.febPrixUoGrille) | number:'1.2-2') + ' €/j'
           : '—' }}
      </span>
    </div>
    <div class="info-item">
      <span class="label">Prix UO proposé</span>
      <span class="value">
        {{ data.devisPrixUoPropose != null ? (data.devisPrixUoPropose | number:'1.2-2') + ' €/j' : '—' }}
      </span>
    </div>
    <div class="info-item">
      <span class="label">Date démarrage GO</span>
      <span class="value">
        {{ data.devisDateDemarrageGo ? (data.devisDateDemarrageGo | date:'dd/MM/yyyy') : '—' }}
      </span>
    </div>
    <div class="info-item">
      <span class="label">Durée prévisionnelle</span>
      <span class="value">{{ data.devisDuree != null ? data.devisDuree + ' j' : '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">Provision frais</span>
      <span class="value">
        {{ data.devisProvisionFrais != null ? (data.devisProvisionFrais | number:'1.2-2') + ' €' : '—' }}
      </span>
    </div>
    <!-- ── Date d'entretien ───────────────────────────── -->
    <div class="info-item">
      <span class="label">Date d'entretien</span>
      <span class="value">
        {{ data.dateEntretien ? (data.dateEntretien | date:'dd/MM/yyyy') : '—' }}
      </span>
    </div>
    <div class="info-item highlight-total">
      <span class="label">Montant total prévisionnel</span>
      <span class="value">
        {{ data.devisMontantTotal != null ? (data.devisMontantTotal | number:'1.2-2') + ' €' : '—' }}
      </span>
    </div>
  </div>

  <!-- ───────── SECTION 3 : FEB ───────── -->
  <div class="section-title">Fiche Expression de Besoin</div>
  <div class="info-grid">
    <div class="info-item">
      <span class="label">Libellé FEB</span>
      <span class="value">{{ data.febLabel ?? '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">UO / Activité pressentie</span>
      <span class="value">{{ data.febUoActivitePressentiLabel ?? '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">Nomenclature</span>
      <span class="value">{{ data.febNomenclature ?? '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">Localisation</span>
      <span class="value">{{ data.febLocalisationLabel ?? '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">PC SNCF</span>
      <span class="value">{{ data.febPcSncf != null ? (data.febPcSncf ? 'Oui' : 'Non') : '—' }}</span>
    </div>
    <div class="info-item">
      <span class="label">Présence site SNCF</span>
      <span class="value">{{ data.febPresenceSiteSncf ?? '—' }}</span>
    </div>
    <div class="info-item span-2" *ngIf="data.febContexteObjectifProjet">
      <span class="label">Contexte et objectif</span>
      <span class="value">{{ data.febContexteObjectifProjet }}</span>
    </div>
  </div>

  <!-- Activités -->
  <div *ngIf="data.febActivites && data.febActivites.length > 0" class="activites-section">
    <div class="subsection-title">Activités</div>
    <table class="activites-table">
      <thead>
        <tr>
          <th>Activité</th>
          <th class="pct-col">Répartition</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let a of data.febActivites">
          <td>{{ a.label }}</td>
          <td class="pct-col">{{ a.pourcentage }} %</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ───────── COMMENTAIRE CDC ───────── -->
  <div *ngIf="data.devisCommentaire" class="commentaire-section">
    <div class="section-title">Commentaire CDC</div>
    <p class="commentaire-text">{{ data.devisCommentaire }}</p>
  </div>

  <!-- ───────── INFORMATIONS DE DÉCISION ───────── -->
  <ng-container *ngIf="data.devisMotifRefus || data.devisMotifRetourArriere || data.devisNumeroBdc || data.devisDateFinTravaux">
    <div class="section-title">Informations de décision</div>

    <div *ngIf="data.devisMotifRefus" class="decision-block block-refuse">
      <div class="decision-label">
        <mat-icon>cancel</mat-icon> Motif de refus
      </div>
      <p class="decision-text">{{ data.devisMotifRefus }}</p>
    </div>

    <div *ngIf="data.devisMotifRetourArriere" class="decision-block block-retour">
      <div class="decision-label">
        <mat-icon>undo</mat-icon> Motif du retour en arrière (EN ATTENTE → CRÉÉ)
      </div>
      <p class="decision-text">{{ data.devisMotifRetourArriere }}</p>
    </div>

    <div *ngIf="data.devisNumeroBdc || data.devisDateFinTravaux" class="decision-block block-accepte">
      <div class="decision-label">
        <mat-icon>check_circle</mat-icon> Informations d'acceptation
      </div>
      <div class="decision-details">
        <span *ngIf="data.devisNumeroBdc">
          <strong>N° BDC :</strong> {{ data.devisNumeroBdc }}
        </span>
        <span *ngIf="data.devisDateFinTravaux">
          <strong>Date fin travaux :</strong> {{ data.devisDateFinTravaux | date:'dd/MM/yyyy' }}
        </span>
      </div>
    </div>
  </ng-container>

  <!-- ───────── COLLABORATEURS ASSOCIÉS (CDC §5.3) ───────── -->
  <div class="section-title">Collaborateurs</div>
  <app-devis-collaborateurs
   [devisId]="data.devisId"
    [readonly]="data.devisStatut !== DevisStatut.CREE">
  </app-devis-collaborateurs>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="openHistory()">
    <mat-icon>history</mat-icon> Historique
  </button>
  <button mat-stroked-button (click)="close()">Fermer</button>
</mat-dialog-actions>